export const Data = [

    {
        productId: 1,
        title: 'PINK VENOM HOODIE ',
        price: 1200,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/files/Untitled-1.png?v=1684877920',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_COLLAGEHOODIE_BACK.png?v=1684877920',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_COLLAGEHOODIE_DETAIL_FRONT.png?v=1684877920'
        ],
        category: 'T-Shirt',
        description: 'Embroidery front + screenprint back.'


    },
    {
        productId: 2,
        title: 'ICE CREAM T-SHIRT',
        price: 1000,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_ICDyeTF.png?v=1598016592',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_ICDyeTF.png?v=1598016592',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_ICDyeTB.png?v=1598016593'
        ],
        category: 'T-Shirt',
        description: 'Pastel tie-dyed tee featuring screenprinted ice cream graphic.'


    },
    {
        productId: 3,
        title: 'BORN PINK TOUR LOGO CREWNECK',
        price: 1500,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_GREYCREW_FRONT.png?v=1681413870',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_GREYCREW_FRONT.png?v=1681413870',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_GREYCREW_BACK.png?v=1681413870'
        ],
        category: 'T-Shirt',
        description: 'Screenprint front graphic.'


    },
    {
        productId: 4,
        title: 'ICE CREAM L/S I',
        price: 460,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_PnkLSF_0d2b356b-059a-4a3d-ad53-98d5f46df339.png?v=1598016697',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_PnkLSF_0d2b356b-059a-4a3d-ad53-98d5f46df339.png?v=1598016697',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_PnkLSB_801fe997-a4a1-40f8-bb46-e828ccf612fe.png?v=1598016697,'
        ],
        category: 'T-Shirt',
        description: 'Pink long sleeve tee featuring screenprinted ice cream graphic on the front.'


    },
    {
        productId: 5,
        title: 'BORN PINK TOUR HAT',
        price: 400,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_DADHAT_FRONT.png?v=1681414758',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_DADHAT_FRONT.png?v=1681414758',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_DADHAT_BACK.png?v=1681414758',

        ],
        category: 'Accessories',
        description: 'Embroidered dad hat'


    },


    {
        productId: 6,
        title: 'BORN PINK TOUR LOGO BABY T-SHIRT',
        price: 500,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_WHITECROP_FRONT.png?v=1681412517',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_WHITECROP_FRONT.png?v=1681412517',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BP_WHITECROP_DETAIL.png?v=1681412497'
        ],
        category: 'T-Shirt',
        description: 'Screenprint front graphic'


    },


    {
        productId: 8,
        title: 'THE SHOW KEYCHAIN I',
        price: 250,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/KEYCHAIN1.png?v=1611673304',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/KEYCHAIN1.png?v=1611673304',


        ],
        category: 'Accessories',
        description: 'METAL KEYCHAIN FEATURING BLACKPINK THE SHOW GRAPHICS'


    },
    {
        productId: 9,
        title: 'STANDARD LP',
        price: 600,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPLP.png?v=1595876400',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPLP.png?v=1595876400',


        ],
        category: 'Album',
        description: 'Tracklist: 1. How You Like That 2. Ice Cream (feat. Selena Gomez) 3. Pretty Savage 4. Bet You Wanna (feat. Cardi B) 5. Lovesick Girls 6. Crazy Over You 7. Love To Hate Me 8. You Never Know '

    },

    {
        productId: 10,
        title: 'ICE CREAM SUNGLASSES',
        price: 400,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_Glasses.png?v=1598580813',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_Glasses.png?v=1598580813',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/BPSG_Shades.png?v=1598580813'


        ],
        category: 'Accessories',
        description: 'PINK TINTED ICE CREAM SUNGLASSES, INCLUDES A DRAWSTRING POUCH.'



    },
    {
        productId: 11,
        title: 'SHUT DOWN NECKLACE',
        price: 300,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/blackpinkneck.png?v=1663265981',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/blackpinkneck.png?v=1663265981'


        ],
        category: 'Accessories',
        description: 'Custom silver with enamel necklace'



    },
    {
        productId: 12,
        title: 'THE SHOW SCRUNCHIE SET',
        price: 200,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/SCRUNCHIE_587x.png?v=1611673302',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/SCRUNCHIE_587x.png?v=1611673302'


        ],
        category: 'Accessories',
        description: 'WHITE, PINK & BLACK SCRUNCHIE SET FEATURING BLACKPINK THE SHOW GRAPHICS'



    },
    {
        productId: 13,
        title: 'THE SHOW T-SHIRT',
        price: 300,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/SS2FRONT.png?v=1611673263',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/SS2FRONT.png?v=1611673263',
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/SS2BACK.png?v=1611673263'


        ],
        category: 'T-Shirt',
        description: 'Black unisex crewneck tee featuring BLACKPINK The Show graphics.'


    },
    {
        productId: 14,
        title: 'BLACKPINK OFFICIAL LIGHT STICK',
        price: 450,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/LIGHTSTICK_grande_89223388-e239-485e-a5b4-9385e21408db_429x.png?v=1555519845',
        quantity: 1,
        subImg: [
            'https://cdn.shopify.com/s/files/1/0022/5011/3123/products/LIGHTSTICK_grande_89223388-e239-485e-a5b4-9385e21408db_429x.png?v=1555519845',


        ],
        category: 'Accessories',
        description: 'Black and pink lightstick'


    },



]
